<template>
  <div class="card red">
    <div class="form-title">
      <font-awesome-icon class="icon" :icon="['fas', 'heart']" />

      Mes plats préférés
    </div>

    <div style="display: flex; flex-direction: column ;gap: 20px;flex-wrap: wrap;">
      <div v-for="dish of recipes" :key="dish.id" class="card liked-dish"
        :style="{ backgroundImage: 'url(' + mediaSrc(dish.photo) + ')' }" @click="gotoDish(dish)">
        <div class="overlay">
          <div class="liked-dish-name">{{ dish.name }}</div>
        </div>
      </div>

      <!-- See all -->
      <router-link v-if="recipes.length > 0" class="card liked-dish" :to="{ name: 'my-liked-recipes' }">
        <div class="liked-dish-name">Voir tous mes plats préférés</div>
      </router-link>
    </div>
  </div>
</template>


<script>

import { api } from "@/api";

export default {
  name: "MyLikedRecipes",
  data() {
    return {
      recipes: [],
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      api.get(`my-liked-recipes/`)
        .then(response => {
          this.recipes = response.data;
        });
    },
    mediaSrc(uri) {
      return `${process.env.VUE_APP_BASE_URL}${uri}`;
    },
    gotoDish(dish) {
      this.$router.push({ name: "dish", params: { id: dish.id } });
    },
  },
};

</script>


<style scoped>
.liked-dish {
  position: relative;
  height: 150px;
  background-size: cover;
  background-position: center;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.liked-dish:hover {
  transform: scale(1.01);
}

.overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;
}

.liked-dish:hover .overlay {
  background-color: rgba(255, 255, 255, 0.7);
}

.liked-dish-name {
  font-size: 20px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 10px;
}
</style>
